import { getAttributeValue, setAttributeValue, clearAttributeValue } from './utils';

const baseInfo = {
    state: {
        dm: '',     // 大坝信信息
        dms: '',    // 大坝测点信息
        bas: '',    // 流域信息
        res: '',    // 水库信息
        hys: '',    // 水电站信息
        dt: '',     // 部门信息
        rg: '',     // 行政区划
        ut: '',     // 单位信息
        st: '',     // 测站信息
        wmSt: '',   // 视频站信息
        wt: '',     // 预警类型
        wg: '',     // 预警等级
        wd: '',     // 预警部门
    },
    getters: {
        // 获取大坝信息
        getDm(state) {
            return getAttributeValue(state, "dm");
        },
        // 获取大坝测点信息
        getDms(state) {
            return getAttributeValue(state, "dms");
        },
        // 获取流域信息
        getBas(state) {
            return getAttributeValue(state, "bas");
        },
        // 获取水库信息
        getRes(state) {
            return getAttributeValue(state, "res");
        },
        // 获取水电站信息
        getHys(state) {
            return getAttributeValue(state, "hys");
        },
        // 获取部门信息
        getDt(state) {
            return getAttributeValue(state, "dt");
        },
        // 获取行政区划
        getRg(state) {
            return getAttributeValue(state, "rg");
        },
        // 获取测站信息
        getSt(state) {
            return getAttributeValue(state, "st");
        },
        // 获取视频测站信息
        getWmSt(state) {
            return getAttributeValue(state, "wmSt");
        },
        // 获取单位信息
        getUt(state) {
            return getAttributeValue(state, "ut");
        },
        // 获取预警类型
        getWt(state) {
            return getAttributeValue(state, "wt");
        },
        // 获取预警等级
        getWg(state) {
            return getAttributeValue(state, "wg");
        },
        // 获取预警部门
        getWd(state) {
            return getAttributeValue(state, "wd");
        },
    },
    mutations: {
        // 设置大坝信息
        SET_DM: (state, dm) => {
            setAttributeValue(state, "dm", dm);
        },
        // 设置大坝测点信息
        SET_DMS: (state, dms) => {
            setAttributeValue(state, "dms", dms);
        },
        // 设置流域信息
        SET_BAS: (state, bas) => {
            setAttributeValue(state, "bas", bas);
        },
        // 设置水库信息
        SET_RES: (state, res) => {
            setAttributeValue(state, "res", res);
        },
        // 设置水电站信息
        SET_HYS: (state, hys) => {
            setAttributeValue(state, "hys", hys);
        },
        // 设置部门信息
        SET_DT: (state, dt) => {
            setAttributeValue(state, "dt", dt);
        },
        // 设置行政区划
        SET_RG: (state, rg) => {
            setAttributeValue(state, "rg", rg);
        },
        // 设置测站信息
        SET_ST: (state, st) => {
            setAttributeValue(state, "st", st);
        },
        // 设置视频测站信息
        SET_WM_ST: (state, wmSt) => {
            setAttributeValue(state, "wmSt", wmSt);
        },
        // 设置单位信息
        SET_UT: (state, ut) => {
            setAttributeValue(state, "ut", ut);
        },
        // 设置预警类型
        SET_WT: (state, wt) => {
            setAttributeValue(state, "wt", wt);
        },
        // 设置预警等级
        SET_WG: (state, wg) => {
            setAttributeValue(state, "wg", wg);
        },
        // 设置预警部门
        SET_WD: (state, wd) => {
            setAttributeValue(state, "wd", wd);
        },
        // 清除大坝缓存
        CLEAR_DM: (state) => {
            state.dm = "";
            // 同步清除session
            clearAttributeValue("dm");
        },
        // 清除大坝测点缓存
        CLEAR_DMS: (state) => {
            state.dms = "";
            // 同步清除session
            clearAttributeValue("dms");
        },
        // 清除流域缓存
        CLEAR_BAS: (state) => {
            state.bas = "";
            // 同步清除session
            clearAttributeValue("bas");
        },
        // 清除水库缓存
        CLEAR_RES: (state) => {
            state.res = "";
            // 同步清除session
            clearAttributeValue("res");
        },
        // 清除水电站缓存
        CLEAR_HYS: (state) => {
            state.hys = "";
            // 同步清除session
            clearAttributeValue("hys");
        },
        // 清除部门缓存
        CLEAR_DT: (state) => {
            state.dt = "";
            // 同步清除session
            clearAttributeValue("dt");
        },
        // 清除行政区划缓存
        CLEAR_RG: (state) => {
            state.rg = "";
            // 同步清除session
            clearAttributeValue("rg");
        },
        // 清除测站缓存
        CLEAR_ST: (state) => {
            state.st = "";
            // 同步清除session
            clearAttributeValue("st");
        },
        // 清除视频测站缓存
        CLEAR_WM_ST: (state) => {
            state.wmSt = "";
            // 同步清除session
            clearAttributeValue("wmSt");
        },
        // 清除单位缓存
        CLEAR_UT: (state) => {
            state.ut = "";
            // 同步清除session
            clearAttributeValue("ut");
        },
        // 清除预警类型
        CLEAR_WT: (state) => {
            state.wt = "";
            // 同步清除session
            clearAttributeValue("wt");
        },
        // 清除预警等级
        CLEAR_WG: (state) => {
            state.wg = "";
            // 同步清除session
            clearAttributeValue("wg");
        },
        // 清除预警部门
        CLEAR_WD: (state) => {
            state.wd = "";
            // 同步清除session
            clearAttributeValue("wd");
        }
    },
    actions: {
        // 设置大坝信息
        setDm({ commit }, dm) {
            commit('SET_DM', dm);
        },
        // 设置大坝测点信息
        setDms({ commit }, dms) {
            commit('SET_DMS', dms);
        },
        // 设置流域信息
        setBas({ commit }, bas) {
            commit('SET_BAS', bas);
        },
        // 设置水库信息
        setRes({ commit }, res) {
            commit('SET_RES', res);
        },
        // 设置水电站信息
        setHys({ commit }, hys) {
            commit('SET_HYS', hys);
        },
        // 设置部门信息
        setDt({ commit }, dt) {
            commit('SET_DT', dt);
        },
        // 设置行政区划
        setRg({ commit }, rg) {
            commit('SET_RG', rg);
        },
        // 设置测站
        setSt({ commit }, st) {
            commit('SET_ST', st);
        },
        // 设置视频测站
        setWmSt({ commit }, wmSt) {
            commit('SET_WM_ST', wmSt);
        },
        // 设置单位
        setUt({ commit }, ut) {
            commit('SET_UT', ut);
        },
        // 设置预警类型
        setWt({ commit }, wt) {
            commit('SET_WT', wt);
        },
        // 设置预警等级
        setWg({ commit }, wg) {
            commit('SET_WG', wg);
        },
        // 设置预警部门
        setWd({ commit }, wd) {
            commit('SET_WD', wd);
        },
        // 清除大坝缓存
        clearDm: ({ commit }) => {
            // 同步清除session
            commit('CLEAR_DM');
        },
        // 清除大坝缓存
        clearDms: ({ commit }) => {
            // 同步清除session
            commit('CLEAR_DMS');
        },
        // 清除流域缓存
        clearBas: ({ commit }) => {
            // 同步清除session
            commit('CLEAR_BAS');
        },
        // 清除水库缓存
        clearRes: ({ commit }) => {
            // 同步清除session
            commit('CLEAR_RES');
        },
        // 清除水电站缓存
        clearHys: ({ commit }) => {
            // 同步清除session
            commit('CLEAR_HYS');
        },
        // 清除部门缓存
        clearDt: ({ commit }) => {
            // 同步清除session
            commit('CLEAR_DT');
        },
        // 清除行政区划缓存
        clearRg: ({ commit }) => {
            // 同步清除session
            commit('CLEAR_RG');
        },
        // 清除测站缓存
        clearSt: ({ commit }) => {
            // 同步清除session
            commit('CLEAR_ST');
        },
        // 清除视频测站缓存
        clearWmSt: ({ commit }) => {
            // 同步清除session
            commit('CLEAR_WM_ST');
        },
        // 清除单位缓存
        clearUt: ({ commit }) => {
            // 同步清除session
            commit('CLEAR_UT');
        },
        // 清除预警类型
        clearWt: ({ commit }) => {
            // 同步清除session
            commit('CLEAR_WT');
        },
        // 清除预警等级
        clearWg: ({ commit }) => {
            // 同步清除session
            commit('CLEAR_WG');
        },
        // 清除预警部门
        clearWd: ({ commit }) => {
            // 同步清除session
            commit('CLEAR_WD');
        }
    }
}

export default baseInfo;


// WEBPACK FOOTER //
// ./src/store/modules/base-info.js